import styled from 'styled-components';

/**
 * @license
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 */
var Input = styled.input.attrs(function (_ref) {
  var invalid = _ref.invalid,
      defaultChecked = _ref.defaultChecked,
      indeterminate = _ref.indeterminate;
  return {
    className: 'gz-input-checkbox',
    type: 'checkbox',
    'aria-invalid': invalid,
    'aria-checked': function () {
      var ariaChecked = defaultChecked;

      if (indeterminate && defaultChecked) {
        ariaChecked = 'mixed';
      }

      return ariaChecked;
    }()
  };
}).withConfig({
  componentId: "gz-checkbox-1673535246793__sc-qcwqhq-0"
})(["border:0;clip:rect(0 0 0 0);clip:rect(0px,0px,0px,0px);clip-path:inset(50%);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;white-space:nowrap;width:1px;"]);

export { Input as I };
